import { Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import * as CryptoJS from 'crypto-js';
import { environment } from 'src/environments/environment';

const TOKEN_KEY = 'KenindiaCustomerToken';
const REFRESH_TOKEN = 'Refresh-Token';
const CUSTOMER_TOKEN='Customer-Token'

@Injectable({
  providedIn: 'root'
})
export class TokenStorage  {

  constructor(private cookieService:CookieService) {
  }

  save(token: any) {
    window.localStorage[TOKEN_KEY] = token;
  }

  get() {
    if (window.localStorage[TOKEN_KEY]) {
      return window.localStorage[TOKEN_KEY];
    } else {
      return ''
    }
  }

  destroy() {
    window.localStorage.removeItem(TOKEN_KEY);
  }

  saveRT(token: any) {
    window.localStorage[REFRESH_TOKEN] = token;
  }
  getRT() {
    if (window.localStorage[REFRESH_TOKEN]) {
      return window.localStorage[REFRESH_TOKEN];
    } else {
      return ''
    }
  }
  destroyRT() {
    window.localStorage.removeItem(REFRESH_TOKEN);
  }

  getRefreshToken(){
    const encryptedValue = this.cookieService.get('RefreshToken'); // Get the encrypted token from the cookie

    // Decrypt the token using CryptoJS
    const decryptedBytes = CryptoJS.AES.decrypt(encryptedValue, 'refresh_token');
    
    // Convert the decrypted bytes to a string
    const decryptedRFToken = decryptedBytes.toString(CryptoJS.enc.Utf8);
    return decryptedRFToken;
  }

}
